import React from 'react';
import bloodDonorImage from '../assets/images/blood_donor.png';
import '../styles/Register.css';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const navigate = useNavigate();
  const handleBloodRegistration = () => {
    navigate('/register')
  }

  return (
    <div className="register-section">
      <div className="image-text-container">
        <img src={bloodDonorImage} alt="Blood Donor" className="blood-image" />
        <h1 className="register-heading">
          <span className="blood">Blood Bank</span> <span className="reg">Registration</span>
        </h1>
      </div>
      <button className="coming-soon-button" onClick={handleBloodRegistration}>Blood Bank Registration</button>
    </div>
  );
};

export default Register;
